var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiModal',{attrs:{"title":_vm.displayTitle,"description":_vm.globalDialog.description,"actions":_vm.actions},model:{value:(_vm.isOpen),callback:function ($$v) {_vm.isOpen=$$v},expression:"isOpen"}})
}
var staticRenderFns = []

export { render, staticRenderFns }